import { AUTH_CURRENT_USER_GQL } from './gql';
import { apolloClient } from '../client';
import { AuthPayload } from '../types.generated';

export const currentUserQuery = async (): Promise<AuthPayload> => {
  const response = await apolloClient.query({
    query: AUTH_CURRENT_USER_GQL,
    variables: {},
  });

  return response.data ? response.data.currentUser : null;
};
